import './AlarmNoteModal.scss';

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import LockIcon from '@mui/icons-material/LockSharp';
import moment from 'moment';

import Modal from '@mui/material/Modal';
import NuisanceIcon from '@mui/icons-material/BugReportSharp';
import LotoIcon from '@mui/icons-material/LocalOfferSharp';
import ResetIcon from '@mui/icons-material/CallMissedSharp';
import FeatureFence from 'src/component/FeatureFence';
import Button from 'src/component/UI/Button';
import NoteModal from 'src/component/UI/NoteModal';
import { Tooltip } from '@mui/material';
import PermissionFence from 'src/component/PermissionFence';
import { useTranslation } from 'src/i18n';
export default function AlarmNoteModal (props) {
  const { t } = useTranslation();
  const [selectedStatus, setSelectedStatus] = useState('');

  useEffect(() => {
    setSelectedStatus('');
  }, [props.open]);

  const handleClick = (status) => () => {
    setSelectedStatus(status);
  };

  const handleSubmit = (status, expiry=null, subject=null, workTicket=null) => () => {
    setSelectedStatus('');
    props.handleSubmit(status, expiry, subject, workTicket);
  };

  const alarmsMap = {};

  if (props.alarms) {
    props.alarms.forEach((alarm) => {
      alarmsMap[alarm.get('alarm')] = 1;
    });
  }

  const alarms = Object.keys(alarmsMap);

  let canNuisance = false;
  if (alarms.length === 1 && (alarms[0] === 'low temp' || alarms[0] === 'low load')) {
    canNuisance = true;
  }

  let canNote = true;
  if (!props.circuitId && !props.controllerId && !props.deviceId) {
    canNote = false;
    canNuisance = false;
  }

  const statusLabels = {
    loto: t('alarmNote.loto'),
    nuisance: t('alarmNote.nuisance')
  };
  const restAlarmButton = (locked) => {
    return <Button cta className='large-btn centered' disabled={locked} backgroundColor='error' onClick={handleSubmit('dismiss')} icon={<ResetIcon style={{ fontSize: 14 }} />} >{t('alarmNote.resetAlarm')}</Button>;
  };

  if (selectedStatus === 'loto' || selectedStatus === 'nuisance') {
    return (
      <NoteModal
        open={props.open}
        noteType={selectedStatus}
        deviceId={props.deviceId || props.circuitId || props.controllerId}
        deviceReadOnly
        alarm={selectedStatus === 'nuisance' ? alarms[0] : ''}
        handleClose={props.handleClose}
        handleSubmit={(note) => {
          const expiredAt = note.get('expired_at');
          handleSubmit(
            selectedStatus,
            expiredAt ? moment(expiredAt).format('YYYY-MM-DD') : null,
            note.get('subject'),
            note.get('work_ticket') || null
          )();
        }}
      />
    );
  }

  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby='alarm-note-modal-title'
    >
      <div className='modal alarm-note-modal'>
        <div>
          <h2 id='alarm-note-modal-title'>{t('alarmNote.addNote', { type: statusLabels[selectedStatus] || '' })}</h2>
        </div>

        <div className='dismiss-form'>
          <Button cta className='large-btn' disabled={!canNote} backgroundColor='primary' onClick={handleClick('loto')} icon={<LotoIcon style={{ fontSize: 14 }} />} >{t('alarmNote.loto')}</Button>
          <Button cta className='large-btn' disabled={!canNuisance} backgroundColor='primary' onClick={handleClick('nuisance')} icon={<NuisanceIcon style={{ fontSize: 14 }} />} >{t('alarmNote.nuisance')}</Button>
          <div>
            <PermissionFence can='reset-alarms'>
              <FeatureFence can={['program-device']}
                // !feature & permission = show lock
                noPermissionComponent={
                  <Tooltip title={t('alarmNote.talkToAdmin')} placement='right'>
                    <div style={{ position: 'relative' }}>
                      {restAlarmButton(true)}
                      <span style={{ position: 'absolute', top: '15px', right: '5px' }}><LockIcon fontSize='medium' /></span>
                    </div>
                  </Tooltip>
                }
              >
                {/* Feature & permission = show normal */}
                {restAlarmButton(false)}
              </FeatureFence>
            </PermissionFence>
          </div>
        </div>
      </div>
    </Modal>
  );
}

AlarmNoteModal.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  circuitId: PropTypes.string,
  controllerId: PropTypes.string,
  alarms: ImmutablePropTypes.list,
  deviceId: PropTypes.string,
};

AlarmNoteModal.defaultProps = {
  circuitId: null,
  controllerId: null,
  deviceId: null
};
